import config from "../package.json" assert { type: "json" };
export default config.version;
